import { Switch as SwitchAnt, SwitchProps } from 'antd'
import cl from 'classnames'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface IProps extends SwitchProps {
  title?: string
  description?: Array<string>
  hideDescription?: boolean
  preventInput?: boolean
  value?: boolean
  active?: number
  onChange?: (checked: boolean) => void
}

const StyledLabel = styled.label`
  margin-bottom: 8px;
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
`
const StyledSwitchAnt = styled(SwitchAnt)`
  margin-right: 8px;
`

const StyledSwitchContainer = styled.div<{ $preventInput?: boolean }>`
  display: flex;
  flex-direction: column;

  .active {
    color: var(--color-primary-108);
  }
  .non-active {
    margin-left: 8px;
  }

  button {
    ${({ $preventInput }) => ($preventInput ? 'cursor: not-allowed;' : '')}
  }
`

const Switch = (props: IProps) => {
  const { t } = useTranslation()
  const {
    title,
    description = ['de-active', 'active'],
    hideDescription,
    value,
    onChange,
    preventInput,
    ...resProps
  } = props

  const handleOnChange = (checked: boolean) => {
    if (preventInput) return
    if (onChange) onChange(checked)
  }
  return (
    <StyledSwitchContainer $preventInput={preventInput}>
      {title && <StyledLabel>{t(title)}</StyledLabel>}
      <div>
        <StyledSwitchAnt
          onChange={handleOnChange}
          checked={value}
          {...resProps}
        />
        {!hideDescription && (
          <span className={cl({ active: value })}>
            {t(description[value ? 1 : 0] || '')}
          </span>
        )}
      </div>
    </StyledSwitchContainer>
  )
}

export default Switch
